<script lang="ts">
	// The design system's mark (the artboard's "العلامة", assets/compass-mark.svg):
	// a ring and a needle held at the brand angle, 34 degrees. The ring and the
	// south half take currentColor, so the mark inherits the ink beside it and
	// turns with the ground; north is the speed red written out, because red is
	// a fill and a fill does not invert.
	//
	// It is the resting state of Loading, drawn still. Where something is
	// actually loading, use Loading: it is this mark, hunting.

	interface Props {
		size?: number;
	}

	let { size = 26 }: Props = $props();
</script>

<svg viewBox="0 0 26 26" width={size} height={size} aria-hidden="true">
	<circle cx="13" cy="13" r="11.5" fill="none" stroke="currentColor" stroke-width="2" />
	<g transform="rotate(34 13 13)">
		<rect class="north" x="12" y="5.5" width="2" height="7.5" />
		<rect x="12" y="13" width="2" height="7.5" fill="currentColor" />
	</g>
</svg>

<style>
	svg {
		display: block;
		flex: none;
	}

	.north {
		fill: var(--speed);
	}
</style>
